import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const icon = css`
  inline-size: auto;
  block-size: ${spacing(10.625)}; // 85px
`
export const qr = css`
  image-rendering: pixelated;
`

export const seoHeading = css`
  max-width: 978px;
  margin-block-end: ${spacing(3)};
  font-size: ${spacing(9)};
  line-height: ${spacing(8.5)} !important; // нужно перебить высоту строки Typography
  text-wrap: balance; // непредсказуемые переносы из-за использования танкерных ключей, в части браузеров это свойство предотвратит висящие союзы
`
